import * as React from 'react';
import { useTranslation } from 'react-i18next';
import MoneyView from 'shared/components/MoneyView';
import PercentView from 'components/PercentView';
import { useTariff } from 'hooks/useStocksTariff';

export const Tariff: React.FC = () => {
  const { t } = useTranslation();
  const { min, percent } = useTariff();
  if (!percent) {
    return null;
  }
  return (
    <>
      {t('Enter and leave fee is')} <PercentView>{percent}</PercentView>
      {t('but not less than')} <MoneyView>{min}</MoneyView>
    </>
  );
};
